module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAMFBMVEVHcEz///////////////////////////////////////////////////////////9EPuwCAAAAD3RSTlMAf3f88RP7F3gUem95/XGxgrYDAAAAYklEQVQ4y2NgGAXDAfD5/4eDLxuQJIr/IwFLJIlaXBJcyBIHkC3RR4h/RLGdCSEhgOoufewakLQIoHtFH7sGuBYBTN/rY9cA1SKALcD0sWsAaxHAHsZtGTgCnzVgNAHSCQAAUsN1AcHbUNgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sort-down.png
// module id = 372
// module chunks = 29